<template>
  <div class="signup-form">
    <form action="/" method="POST" class="signup-form-inner">
      <transition name="scale-fade" mode="out-in">
        <div class="step" v-if="step === 1" key="step1">
          <div class="kp-card">
            <div class="row justify-content-center">
              <div class="col-md-10">
                <p class="text-center mb-40">Please provide us with your basic data</p>
                <div class="mb-30">
                  <div class="form-group form-compound-group with-icon">
                    <i class="uil-user"></i>
                    <div class="form-compound half">
                      <div class="input-wrapper">
                        <input v-floating-label id="firstName" name="firstName" v-model="firstName" type="text" class="form-control" @change="$v.firstName.$touch()" />
                        <label for="firstName">First name</label>
                        <div class="field-error" v-if="$v.firstName.$dirty && !$v.firstName.required">First name is required</div>
                        <!-- <div class="field-error" v-if="$v.firstName.$dirty && !$v.firstName.minLength">The value shold be longer</div> -->
                      </div>
                    </div>
                    <div class="form-compound half">
                      <div class="input-wrapper">
                        <input v-floating-label id="lastName" name="lastName" v-model="lastName" type="text" class="form-control" @change="$v.lastName.$touch()" />
                        <label for="lastName">Last name</label>
                        <div class="field-error" v-if="$v.lastName.$dirty && !$v.lastName.required">Last name is required</div>
                        <!-- <div class="field-error" v-if="$v.lastName.$dirty && !$v.lastName.minLength">The value shold be longer</div> -->
                      </div>
                    </div>
                  </div>
                  <div class="form-group with-icon">
                    <i class="uil-envelope"></i>
                    <div class="input-wrapper">
                      <input v-floating-label id="emailAddress" name="emailAddress" v-model="emailAddress" type="email" class="form-control" @change="$v.emailAddress.$touch()" />
                      <label for="emailAddress">Email address</label>
                      <div class="field-error" v-if="$v.emailAddress.$dirty && !$v.emailAddress.required">Email is required</div>
                      <!-- <div class="field-error" v-if="$v.emailAddress.$dirty && !$v.emailAddress.email">The email address is invalid</div> -->
                    </div>
                  </div>
                  <div class="form-group with-icon">
                    <i class="uil-phone"></i>
                    <div class="input-wrapper">
                      <div class="input-suffix">
                        <svg id="flag-icon-css-de" viewBox="0 0 640 480">
                          <path fill="#ffce00" d="M0 320h640v160H0z" />
                          <path d="M0 0h640v160H0z" />
                          <path fill="#d00" d="M0 160h640v160H0z" />
                        </svg>
                      </div>
                      <input v-floating-label id="phoneNumber" name="phoneNumber" v-model="phoneNumber" type="text" class="form-control" @change="$v.phoneNumber.$touch()" />
                      <label for="phoneNumber">Phone</label>
                      <div class="field-prefix">+</div>
                      <div class="field-error" v-if="$v.phoneNumber.$dirty && !$v.phoneNumber.required">Phone number is required</div>
                      <!-- <div class="field-error" v-if="$v.phoneNumber.$dirty && !$v.phoneNumber.minLength">The value shold be longer</div> -->
                      <!-- <div class="field-error" v-if="$v.phoneNumber.$dirty && !$v.phoneNumber.numeric">Phone number should be numeric</div> -->
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <button class="btn btn-wider btn-icon btn-spinner" :class="{disabled: !userValid || isLoading, spinning: isLoading}" @click.prevent="sendSMS">
                    <span class="btn-text">
                      Next
                      <i class="uil-arrow-right"></i>
                    </span>
                    <span class="spinner"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step" v-if="step === 2" key="step2">
          <div class="kp-card">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <p class="text-center mb-40">Please enter the code received by SMS</p>
                <div class="mb-30">
                  <div class="form-group">
                    <div class="form-row sms-input align-items-center" v-focus-next>
                      <div class="col">
                        <input v-model="smsCode[0]" @focus="focusText" @keypress.native="preventInput" id="sms-1" type="text" maxlength="1" class="form-control sms-input" />
                      </div>
                      <div class="col">
                        <input v-model="smsCode[1]" @focus="focusText" @keypress.native="preventInput" id="sms-2" type="text" maxlength="1" class="form-control sms-input" />
                      </div>
                      <div class="col">
                        <input v-model="smsCode[2]" @focus="focusText" @keypress.native="preventInput" id="sms-3" type="text" maxlength="1" class="form-control sms-input" />
                      </div>
                      <div class="col text-center">-</div>
                      <div class="col">
                        <input v-model="smsCode[3]" @focus="focusText" @keypress.native="preventInput" id="sms-4" type="text" maxlength="1" class="form-control sms-input" />
                      </div>
                      <div class="col">
                        <input v-model="smsCode[4]" @focus="focusText" @keypress.native="preventInput" id="sms-5" type="text" maxlength="1" class="form-control sms-input" />
                      </div>
                      <div class="col">
                        <input v-model="smsCode[5]" @focus="focusText" @keypress.native="preventInput" id="sms-6" type="text" maxlength="1" class="form-control sms-input" />
                      </div>
                    </div>
                    <div class="field-error text-center mt-20" v-if="smsInvalid">The code entered is wrong.</div>
                  </div>
                </div>
                <div class="text-center">
                  <button class="btn btn-wider btn-icon btn-spinner" :class="{disabled: !smsCodeValid || isLoading, spinning: isLoading}" @click.prevent="verifyCode()">
                    <span class="btn-text">
                      Next
                      <i class="uil-arrow-right"></i>
                    </span>
                    <span class="spinner"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step" v-if="step === 3" key="step3">
          <div class="kp-card">
            <div class="row justify-content-center">
              <div class="col-md-10">
                <p class="text-center mb-40">Please create a password for your account</p>
                <div class="mb-30">
                  <div class="form-group with-icon">
                    <i class="uil-lock"></i>
                    <div class="input-wrapper">
                      <input v-floating-label id="password" name="password" v-model="password" type="password" class="form-control" @change="$v.password.$touch()" />
                      <label for="password">Password</label>
                      <div class="field-error" v-if="$v.password.$dirty && !$v.password.required">Password is required</div>
                      <!-- <div class="field-error" v-if="$v.password.$dirty && !$v.password.minLength">Password shold be longer</div> -->
                    </div>
                  </div>
                  <div class="form-group with-icon">
                    <i class="uil-lock"></i>
                    <div class="input-wrapper">
                      <input v-floating-label id="passwordRepeat" name="passwordRepeat" v-model="passwordRepeat" type="password" class="form-control" @change="$v.passwordRepeat.$touch()" />
                      <label for="passwordRepeat">Repeat password</label>
                      <div class="field-error" v-if="$v.passwordRepeat.$dirty && !$v.passwordRepeat.required">This field is required</div>
                      <div class="field-error" v-if="$v.passwordRepeat.$dirty && password !== passwordRepeat">The password doesn't match</div>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <button class="btn btn-wider btn-icon" :class="{disabled: !passwordValid}" @click.prevent="nextStep()">
                    Next
                    <i class="uil-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step" v-if="step === 4" key="step4">
          <div class="kp-card">
            <div class="row justify-content-center">
              <div class="col-md-10 text-center">
                <h4 class="mb-20">
                  Great {{ firstName }},
                  <br />you’re signed up now
                </h4>
                <div class="text-center mb-20">
                  <img src="@/assets/hero-man.png" style="max-width: 220px;" alt />
                </div>
                <p>You will now enter your Dashboard.</p>
                <p class="mb-20">
                  In order to activate your account, please complete
                  your configuration and registration.
                </p>
                <div class="text-center">
                  <router-link to="/dashboard" class="btn btn-icon">
                    Go to Dashboard
                    <i class="uil-arrow-right"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { mapFields } from 'vuex-map-fields'
import { required, minLength, email, numeric } from 'vuelidate/lib/validators'
// import smoothReflow from 'vue-smooth-reflow'
import Logo from '@/components/header/Logo.vue'

export default {
  name: 'signup-form',
  // mixins: [smoothReflow],
  components: {
    Logo
  },
  data() {
    return {
      passwordRepeat: '',
      smsCode: [],
      isLoading: false,
      smsInvalid: false,
      phoneNumber: ''
    }
  },
  computed: {
    ...mapFields({
      firstName: 'user.firstName',
      lastName: 'user.lastName',
      emailAddress: 'user.email',
      phone: 'user.phone',
      password: 'user.password',
      step: 'ui.signupStep',
      signupFinished: 'ui.signupFinished'
    }),
    userValid() {
      return !this.$v.firstName.$invalid && !this.$v.lastName.$invalid && !this.$v.emailAddress.$invalid && !this.$v.phoneNumber.$invalid
    },
    passwordValid() {
      return !this.$v.password.$invalid && !this.$v.passwordRepeat.$invalid && this.password === this.passwordRepeat
      // return !this.$v.password.$invalid && !this.$v.passwordRepeat.$invalid
    },
    smsCodeValid() {
      return this.smsCode.length === 6
    }
  },
  watch: {
    phoneNumber(val) {
      this.phone = `+${val}`
    }
  },
  methods: {
    nextStep() {
      this.$store.commit('incrementStep')
    },
    focusText($event) {
      $event.target.select()
    },
    preventInput() {
      if (this.value.length >= 2) {
        return false
      }
    },
    sendSMS() {
      this.isLoading = true
      const code = Math.floor(100000 + Math.random() * 900000)
      axios
        .post('https://kopplr-sms.herokuapp.com/sms/', {
          from: 'kopplr',
          text: `Hi ${this.firstName}, welcome to kopplr - your registration code is ${code}`,
          to: this.phoneNumber
        })
        .then(response => {
          if (response.data.success) {
            localStorage.setItem('kopplrSMS', code)
            this.isLoading = false
            this.nextStep()
          }
        })
        .catch(err => {
          console.log(err)
          this.isLoading = false
        })
    },
    verifyCode() {
      this.isLoading = true
      setTimeout(() => {
        const code = localStorage.getItem('kopplrSMS')
        const enteredCode = this.smsCode.join('')
        if (parseInt(enteredCode) === parseInt(code)) {
          this.isLoading = false
          this.nextStep()
        } else {
          this.isLoading = false
          this.smsInvalid = true
        }
      }, 1500)
    }
  },
  validations: {
    firstName: {
      required
      // minLength: minLength(4)
    },
    lastName: {
      required
      // minLength: minLength(4)
    },
    emailAddress: {
      required,
      email
    },
    phoneNumber: {
      required
      // numeric,
      // minLength: minLength(4)
    },
    password: {
      required
      // minLength: minLength(8)
    },
    passwordRepeat: {
      required
    }
  },
  directives: {
    'focus-next': {
      inserted(el) {
        const inputs = el.querySelectorAll('.form-control')
        for (let i = 0; i < inputs.length; i++) {
          if (i + 1 < inputs.length) {
            inputs[i].oninput = () => {
              inputs[i + 1].focus()
            }
          }
        }
      }
    }
  },
  mounted() {
    // this.$smoothReflow({
    //   el: '.signup-form-inner',
    //   transitionEvent: {
    //     selector: '.step',
    //     propertyName: 'opacity'
    //   }
    // })
  }
}
</script>
